import React from "react";

/**
 * אייקוני SVG לתוספות טיסה — כבודה מטען vs טרולי (ידני).
 */
export function FlightExtraTypeIcon({ type, className = "" }) {
  const isTrolley = type === "TROLLEY";
  const cn = `fb-extra-type-icon ${className}`.trim();

  if (isTrolley) {
    return (
      <svg
        className={cn}
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <rect
          x="6"
          y="10"
          width="22"
          height="18"
          rx="3"
          stroke="currentColor"
          strokeWidth="1.75"
        />
        <path
          d="M10 10V8a2 2 0 012-2h10a2 2 0 012 2v2"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
        />
        <circle cx="13" cy="30" r="2.25" fill="currentColor" />
        <circle cx="25" cy="30" r="2.25" fill="currentColor" />
        <path
          d="M28 14h4l2 6v8h-3"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      className={cn}
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <rect
        x="8"
        y="11"
        width="20"
        height="16"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path
        d="M12 11V9a1.5 1.5 0 011.5-1.5h9A1.5 1.5 0 0124 9v2"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M10 18h16M10 22h12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.45"
      />
      <path
        d="M14 29h10"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
